import { NgModule } from '@angular/core';
import { MobileShellComponent } from './mobile-shell.component';

@NgModule({
  imports: [MobileShellComponent],
  exports: [MobileShellComponent]
})
export class MobileShellModule {}
